module.exports = __webpack_public_path__ + "img/Govava_Wait_icon.a2231927.gif";